module.exports = __webpack_public_path__ + "static/media/cikrle6.7182969b.jpg";